import { SENSORS_SAMPLES_ENDPOINT } from '../constants/EndPoints';
import { fetchMiddleware } from './MiddlewareActions';

// Sensor Samples Report (WEB-1092). Holds only the dialog open-state + the
// sensor ids it should open pre-filled with; the fetched rows live in the
// dialog's local state (mirrors MultiDayTrendDialog).

const MAX_SENSORS = 15;

const actionsTypes = {
  OPEN_SENSOR_SAMPLES_REPORT: 'OPEN_SENSOR_SAMPLES_REPORT',
  CLOSE_SENSOR_SAMPLES_REPORT: 'CLOSE_SENSOR_SAMPLES_REPORT',
};

export const initialState = {
  open: false,
  initialSensorIds: [],
};

export const openSensorSamplesReport = (sensorIds) => ({
  type: actionsTypes.OPEN_SENSOR_SAMPLES_REPORT,
  payload: (sensorIds || []).map(String).slice(0, MAX_SENSORS),
});

export const closeSensorSamplesReport = () => ({
  type: actionsTypes.CLOSE_SENSOR_SAMPLES_REPORT,
});

// Endpoint: GET /sensorsamples/:projectId?sensorIds=<id1,id2,...>&from=<YYYY-MM-DD>&to=<YYYY-MM-DD>
// (request param names are the client's assumption — confirm with Liron).
// Confirmed response row fields:
//   { ID, SensorID, DeviceID, SampleTime (epoch ms), sample_noise, min_noise,
//     sample_noise_low_freq, sample_noise_med_freq, sample_noise_high_freq,
//     min_noise_low_freq, min_noise_med_freq, min_noise_high_freq }
// If the backend ends up per-sensor, swap the body for a Promise.all of one call
// per id and concat the rows — callers only depend on the resolved rows array.
export const fetchSensorSamples = (projectId, sensorIds, from, to) =>
  (dispatch, getState) => {
    const ids = (sensorIds || []).slice(0, MAX_SENSORS).map(String);
    if (!ids.length || projectId == null) {
      return Promise.resolve([]);
    }
    const query =
      `?sensorIds=${encodeURIComponent(ids.join(','))}` +
      `&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
    const url = `${SENSORS_SAMPLES_ENDPOINT}/${projectId}${query}`;
    return fetchMiddleware(url, {}, getState).then((json) => {
      if (Array.isArray(json)) return json;
      if (json && json.status === false) {
        throw new Error('sensor_samples_fetch_failed');
      }
      return json && json.data ? json.data : [];
    });
  };

const slice = {
  actions: {
    openSensorSamplesReport,
    closeSensorSamplesReport,
    fetchSensorSamples,
  },

  reducer: (state = initialState, action) => {
    switch (action.type) {
      case actionsTypes.OPEN_SENSOR_SAMPLES_REPORT:
        return { ...state, open: true, initialSensorIds: action.payload };

      case actionsTypes.CLOSE_SENSOR_SAMPLES_REPORT:
        return { ...state, open: false, initialSensorIds: [] };

      default:
        return state;
    }
  },
};

export default slice.actions;

export { slice, MAX_SENSORS };
